const notFoundPage: Record<string, Record<string, string> | string> = {
    notExist: 'Page not found ',
    goTo: 'Go to ',
    main: 'Main ',
    orReturn: 'or return ',
    back: 'Back',
};

export default notFoundPage;
